// src/pages/PrivacyPolicyPage.tsx
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 150px 2rem 4rem;

  @media (max-width: 768px) {
    padding: 120px 1rem 3rem;
  }
`;

const Title = styled(motion.h1)`
  font-size: 2.8rem;
  font-weight: 800;
  color: #000;
  text-align: center;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const Section = styled.section`
  margin-bottom: 3rem;
  line-height: 1.8;
  color: #333;

  h2 {
    font-size: 1.6rem;
    font-weight: 700;
    color: #990147;
    margin: 2.5rem 0 1rem;
  }

  p, li {
    font-size: 1.05rem;
    margin-bottom: 0.8rem;
  }

  ul {
    padding-left: 1.5rem;
    margin: 1rem 0;
  }

  strong {
    color: #000;
  }
`;

const PrivacyPolicyPage: React.FC = () => {
    return (
        <Container>
            <Title
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                Ochrana osobných údajov
            </Title>

            <Section>
                <p>
                    Vážení pacienti,<br />
                    ochrana Vašich osobných a zdravotných údajov je pre nás najvyššou prioritou.
                    Nižšie nájdete informácie o tom, ako spracúvame Vaše údaje v súlade so zákonom č. 18/2018 Z. z.
                    o ochrane osobných údajov a nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 (GDPR).
                </p>
            </Section>

            <Section>
                <h2>1. Prevádzkovateľ</h2>
                <p>
                    <strong>SB Consulting Slovakia, s.r.o.</strong><br />
                    Panónska cesta 3604/17, 851 01 Bratislava – Petržalka<br />
                    IČO: 4 791203<br />
                    Ambulancia: MUDr. Soňa Belanská
                </p>
            </Section>

            <Section>
                <h2>2. Aké údaje spracúvame</h2>
                <p>Spracúvame najmä tieto osobné a zdravotné údaje:</p>
                <ul>
                    <li>Meno a priezvisko</li>
                    <li>Kontaktné údaje (e-mail, telefónne číslo)</li>
                    <li>Adresa bydliska</li>
                    <li>Dátum narodenia, rodné číslo (ak je potrebné)</li>
                    <li>Zdravotné údaje (diagnózy, výsledky vyšetrení, anamnéza, liečba atď.)</li>
                    <li>Údaje z komunikácie s Vami (e-maily, správy z formulára)</li>
                </ul>
            </Section>

            <Section>
                <h2>3. Na akom právnom základe a za akým účelom</h2>
                <ul>
                    <li><strong>Plnenie zmluvy a poskytovanie zdravotnej starostlivosti</strong> (čl. 6 ods. 1 písm. b) a čl. 9 ods. 2 písm. h) GDPR)</li>
                    <li><strong>Ochrana života a zdravia</strong> (čl. 9 ods. 2 písm. c) GDPR)</li>
                    <li><strong>Plnenie zákonných povinností</strong> (vedenie zdravotnej dokumentácie podľa zákona č. 576/2004 Z. z.)</li>
                    <li><strong>Oprávnený záujem</strong> – komunikácia s pacientmi, ochrana práv prevádzkovateľa</li>
                </ul>
            </Section>

            <Section>
                <h2>4. Ako dlho údaje uchovávame</h2>
                <p>
                    Zdravotnú dokumentáciu uchovávame <strong>po dobu 20 rokov</strong> od posledného vyšetrenia
                    (podľa zákona č. 576/2004 Z. z.). Ostatné údaje (napr. e-maily) mažeme najneskôr do 5 rokov
                    po ukončení kontaktu, pokiaľ nie je potrebná dlhšia doba.
                </p>
            </Section>

            <Section>
                <h2>5. Komu údaje poskytujeme</h2>
                <p>Vaše údaje môžu byť sprístupnené len:</p>
                <ul>
                    <li>Zdravotným poisťovniam (na účely úhrady)</li>
                    <li>Laboratóriám a iným zdravotníckym zariadeniam (len so súhlasom alebo pri poskytovaní starostlivosti)</li>
                    <li>Poskytovateľom IT služieb (hosting databázy, cloud) – vždy s uzatvorenou zmluvou o spracúvaní</li>
                    <li>Štátnym orgánom v zmysle zákona (napr. ÚVZ SR)</li>
                </ul>
            </Section>

            <Section>
                <h2>6. Vaše práva</h2>
                <p>Máte právo:</p>
                <ul>
                    <li>požiadať o prístup k svojim údajom</li>
                    <li>na opravu alebo vymazanie údajov</li>
                    <li>na obmedzenie spracúvania</li>
                    <li>namietať spracúvanie</li>
                    <li>podať sťažnosť na Úrad na ochranu osobných údajov SR (www.uoou.sk)</li>
                </ul>
                <p>
                    Žiadosť môžete podať e-mailom na: <strong>sonabelanska@gmail.com</strong>
                </p>
            </Section>

            <Section>
                <h2>7. Bezpečnosť údajov</h2>
                <p>
                    Vaše údaje sú uložené v zabezpečenej databáze s šifrovaným pripojením.
                    Prístup má iba oprávnený personál ambulancie viazaný mlčanlivosťou.
                </p>
            </Section>

            <Section>
                <p>
                    <strong>Platnosť od: 29. novembra 2025</strong><br />
                    Tieto zásady môžeme priebežne aktualizovať. Aktuálna verzia je vždy zverejnená na tejto stránke.
                </p>
            </Section>
        </Container>
    );
};

export default PrivacyPolicyPage;